import StatsRule from "../../../../common/stats-rule";
import FootballState from "../../../../football/state/football-state";
import FootballStatsCategory from "../../../../football/stats/football-stats-category";
import { getSafetyTacklingPlayer } from "../../../../football/utils/context-utils";

export default class FlagSafetyRecordStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Safety &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const teamId = gameContext.getPossessionTeamId();
        const tacklingPlayer = getSafetyTacklingPlayer(play, fragment);

        gameContext.increaseTeamScore(teamId, 2);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: teamId,
            playerId: tacklingPlayer?.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.SAFETY,
            values: {
                completed: 1
            }
        });
    }
}
